import { FC } from 'react';
import { useFundEfficiencyCompareContext } from '../../contexts/fundEfficiencyCompareContext';
import { InteractiveBarChart } from '@/components/InteractiveBarChart';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetFundDetails } from '@/modules/invest/subModules/fund/hooks/useGetFundDetails';
import { useGetMarketCapComparison } from './SingleFundRowChart.hooks';
import {
  transferFundDetailsToData,
  transferMarketCapToData,
} from './SingleFundRowChart.utils';

export const SingleFundRowChart: FC = () => {
  const fundCode = useGetFundCodeFromQuery();
  const {
    handleParallelMarketSymbolSelect,
    handlePeriodSelect,
    selectedParallelMarket: { symbolName },
  } = useFundEfficiencyCompareContext();

  const { fundDetails } = useGetFundDetails(fundCode);

  const {
    data: marketCap,
    isLoading,
    isError,
    isFetching,
    refetch,
  } = useGetMarketCapComparison();

  return (
    <InteractiveBarChart
      blacklist={['1M']}
      chartType="row"
      dataPairs={[
        [fundDetails, transferFundDetailsToData],
        [marketCap?.items, transferMarketCapToData],
      ]}
      defaultPeriod="6M"
      isError={isError}
      isFetching={isFetching}
      isLoading={isLoading}
      periodButtonAnalytics={['Funds_change_aFundvsOtherMarketschartDate']}
      periodButtonId="Funds_change_aFundvsOtherMarketschartDate"
      selectedItemId={symbolName}
      title="مقایسه بازدهی صندوق با بازارهای موازی"
      onItemClick={handleParallelMarketSymbolSelect}
      onPeriodChange={handlePeriodSelect}
      onRefetch={refetch}
    />
  );
};
